<template>
    <div class="inbox-message message-outbound conversation-reply">
        <div class="message-header container-fluid">
            <div class="row">
                <div class="col" style="max-width: 50px;">
                    <avatar :user="user" />
                </div>
                <div class="col">
                    <div>From: <strong>{{ user.name }}</strong></div>
                    <div>To: <strong>{{ $store.getters['inbox/conversations/conversation'].contact.primary_display_as }}</strong></div>
                </div>
                <div class="col text-right">
                    <message-list-status-toggle
                        v-if="isMessageTypeSelectable"
                        style="margin-bottom: 1rem;"
                        :value="selectedMessageType"
                        @input="opt => { this.switchMessageType(opt.value); }"
                        :options="messageTypes"
                    />
                </div>
            </div>
        </div>
        <div class="message-body">
            <compose-message-pane
                v-if="selectedMessageType === 'email' && messageTypes.length > 0 && messageTypeValues.includes(selectedMessageType)"
                ref="pane"
                reply-mode
                @sent="sent"
                @reset="$emit('reset')"
            />
            <compose-text-pane
                v-if="selectedMessageType === 'text' && messageTypes.length > 0 && messageTypeValues.includes(selectedMessageType)"
                ref="pane"
                reply-mode
                @sent="sent"
                @reset="$emit('reset')"
            />
            <div style="padding: 1rem; text-align: center;" v-if="messageTypes.length === 0">
                You must add a telephone or email to this customer to be able to send them messages.
            </div>
            <div style="padding: 1rem; text-align: center;" v-if="!messageTypeValues.includes(selectedMessageType) && messageTypes.length > 0">
                You must add a {{ selectedMessageType === 'text' ? 'number' : 'email' }} to this customer to be able to send them messages.
            </div>
        </div>
    </div>
</template>

<script>
    import ComposeMessagePane from "./ComposeEmailPane";
    import MessageListStatusToggle from "./MessageListStatusToggle";
    import { MessageTypeList } from "../../classes/Api/Inbox";
    import ComposeTextPane from "./ComposeTextPane";

    export default {
        components: {ComposeTextPane, ComposeMessagePane, MessageListStatusToggle },
        mounted() {
            this.selectedMessageType = this.$store.getters[
                'inbox/conversations/conversation'
            ].latest_message.medium
        },
        data() {
            return {
                selectedMessageType: null,
            }
        },
        methods: {
            sent() {
                this.$refs.pane.reset()
                this.$emit('sent')
            },
            switchMessageType(type) {
                this.selectedMessageType = type

                this.$nextTick(() => {
                  this.$refs.pane.reset()
                })
            }
        },
        computed: {
            user() {
                return window.marque.ui.user
            },
            isMessageTypeSelectable() {
                return !!this.$store.getters['inbox/conversations/conversation'].message_box.thread_aggregation
            },
            messageTypeValues() {
                return this.messageTypes.map(messageType => messageType.value)
            },
            messageTypes() {
                let types = MessageTypeList

                let contactPhone = this.$store.getters[
                    'inbox/conversations/conversation'
                ].contact.primary_telephone;

                let contactEmail = this.$store.getters[
                    'inbox/conversations/conversation'
                ].contact.email;

                if (!contactPhone || contactPhone.length === 0 || (contactPhone.substr(0, 2) !== '07' && contactPhone.substr(0, 4) !== '+447')) {
                    types = types.filter(t => t.value !== 'text')
                }

                if (!contactEmail || contactEmail.length === 0) {
                    types = types.filter(t => t.value !== 'email')
                }

                return types
            }
        }
    }
</script>

<style lang="scss">
    @import 'message-styles';

    .inbox-message.message-outbound.conversation-reply {
        .message-header {
            background: white;
            color: #666;
            .row {
                font-weight: normal;

                strong {
                    font-weight: bold;
                }
            }
        }

        .message-quill-editor {
            .ql-container .ql-editor {
                min-height: 150px;
            }
        }
    }
</style>